import { render } from "./QuotationsList.vue?vue&type=template&id=09797bb9&scoped=true&ts=true"
import script from "./QuotationsList.vue?vue&type=script&lang=ts"
export * from "./QuotationsList.vue?vue&type=script&lang=ts"

import "./QuotationsList.vue?vue&type=style&index=0&id=09797bb9&scoped=true&lang=scss"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09797bb9"]])

export default __exports__